import { render, staticRenderFns } from "./19.vue?vue&type=template&id=2301c8b8&scoped=true&"
import script from "./19.vue?vue&type=script&lang=js&"
export * from "./19.vue?vue&type=script&lang=js&"
import style0 from "./19.vue?vue&type=style&index=0&id=2301c8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2301c8b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2301c8b8')) {
      api.createRecord('2301c8b8', component.options)
    } else {
      api.reload('2301c8b8', component.options)
    }
    module.hot.accept("./19.vue?vue&type=template&id=2301c8b8&scoped=true&", function () {
      api.rerender('2301c8b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/19.vue"
export default component.exports